import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const ContactSection = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.message) {
      toast({
        title: 'Peringatan',
        description: 'Mohon lengkapi semua field',
        variant: 'destructive'
      });
      return;
    }

    const whatsappMessage = `Halo Mobius Stories, saya ${formData.name}. ${formData.message}`;
    const whatsappUrl = `https://wa.me/6285174247784?text=${encodeURIComponent(
      whatsappMessage
    )}`;
    
    window.open(whatsappUrl, '_blank');
    
    toast({
      title: 'Berhasil!',
      description: 'Membuka WhatsApp...'
    });
    
    setFormData({ name: '', message: '' });
  };

  return (
    <section id="kontak" className="py-20 lg:py-32 bg-gradient-to-b from-[#C1CCBC]/20 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-fraunces font-bold text-[#00382F] mb-4">
            Hubungi Kami
          </h2>
          <p className="text-lg text-[#658C8D] font-lato max-w-2xl mx-auto">
            Tertarik dengan layanan kami? Mari berdiskusi tentang momen spesial
            Anda
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <form
            onSubmit={handleSubmit}
            className="bg-gradient-to-br from-white to-[#C1CCBC]/10 p-8 lg:p-12 rounded-2xl shadow-xl space-y-6"
          >
            <div className="space-y-2">
              <label
                htmlFor="name"
                className="text-[#00382F] font-lato font-semibold block"
              >
                Nama Lengkap
              </label>
              <Input
                id="name"
                name="name"
                type="text"
                placeholder="Masukkan nama Anda"
                value={formData.name}
                onChange={handleChange}
                className="w-full border-[#C1CCBC] focus:border-[#658C8D] focus:ring-[#658C8D] transition-colors duration-300"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="message"
                className="text-[#00382F] font-lato font-semibold block"
              >
                Pesan
              </label>
              <Textarea
                id="message"
                name="message"
                placeholder="Ceritakan tentang momen spesial Anda..."
                value={formData.message}
                onChange={handleChange}
                rows={6}
                className="w-full border-[#C1CCBC] focus:border-[#658C8D] focus:ring-[#658C8D] transition-colors duration-300 resize-none"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-[#658C8D] text-white hover:bg-[#00382F] py-6 text-lg font-lato font-semibold transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center gap-2 group"
            >
              <Send size={20} className="group-hover:translate-x-1 transition-transform duration-300" />
              Kirim ke WhatsApp
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
